'use strict';

var GridToolbarConfigurationUserDefinedRefDataMarketDirective = function GridToolbarConfigurationUserDefinedRefDataMarketDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-configuration-user-defined-ref-data-market.html'),
    controller: 'GridToolbarConfigurationUserDefinedRefDataMarketController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
      scope.$on('configuration-urd-market:save', function () {
        scope.saveChanges();
      });
    }
  };
};
GridToolbarConfigurationUserDefinedRefDataMarketDirective.$inject = [];
module.exports = GridToolbarConfigurationUserDefinedRefDataMarketDirective;